export default __webpack_public_path__ + "static/media/Banner - Artisan - Black.4ccdffb1.jpg";